import { Tab } from "@mui/material";

// import {
//   PreagendamientoPendientePage,
// } from '@/erp/operaciones/preagendamiento/pages/tables';
import PreagendamientoPendientePageEstadoAceptacion from "@/erp/operaciones/preagendamiento/pages/tables/PreagendamientoPendientePageEstadoAceptacion";
import PreagendamientoRechazadoPage from "@/erp/operaciones/preagendamiento/pages/tables/PreagendamientoRechazadoPage";
import { InstallAsignadaTecnicoOTByState } from "@/erp/tecnico/orden-trabajo/pages";
import {
  EstadosAgendamientoEnumChoice,
  EstadosOrdenTrabajoEnumChoice,
  ModulosEnumChoice,
  ModulosMotivoENUM,
  a11yProps,
  getEnvs,
  hasPermission,
  useTabsFormOnly,
} from "@/shared";
import {
  CustomTabPanel,
  FormTabsOnly,
  SingleBoxTableTabsOnly,
  SingleTableBoxScene,
} from "@/shared/components/ui";
import AgendamientosAprobadosPage from "../AgendamientosAprobadosPage";
import AgendasPendingRecoordinacionPyLPage from "../AgendasPendingRecoordinacionPyLPage";
import ChatAgendamiento1 from "./ChatAgendamiento";
// import { PreagendamientoPendientePage } from '@/erp/operaciones/preagendamiento/pages';
import { PermissionsEnum } from '@/auth/interfaces';
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";


export type AgendamientosPagePyLProps = {};

const AgendamientosPagePyL: React.FC<AgendamientosPagePyLProps> = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAdminPlantaExterna = getEnvs().VITE_NODE_ENV == 'prod' && hasPermission(PermissionsEnum.administrador_planta_externa_permission);
  const initialTabValue = typeof location.state?.tabIndex === "number"
    ? location.state.tabIndex
    : isAdminPlantaExterna ? 6 : 1;

  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue,
  });

  const setFaseVenta = useDiccionarioMotivo().setFaseVenta;
  const setDepartamento = useDiccionarioMotivo().setDepartamento;

  useEffect(() => {
    setFaseVenta(ModulosEnumChoice.AGENDAMIENTO);
    setDepartamento(ModulosMotivoENUM.BITACORA_PYL);
    if (location.state?.tabIndex !== undefined) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  if (isAdminPlantaExterna) {
    return (
      <SingleTableBoxScene title={"Agendamientos"}>
        <SingleBoxTableTabsOnly>
          <FormTabsOnly onChange={handleMethodChange} value={6}>
            <Tab label="Rechazadas Planta Externa" value={6} {...a11yProps(6)} />
          </FormTabsOnly>
        </SingleBoxTableTabsOnly>

        <CustomTabPanel value={6} index={6}>
          <AgendasPendingRecoordinacionPyLPage estado_agendamiento={EstadosAgendamientoEnumChoice.PENDIENTE_RECORDINACION} />
        </CustomTabPanel>

        {/* chat */}
        <ChatAgendamiento1 />
      </SingleTableBoxScene>
    );
  }

  return (
    <SingleTableBoxScene title={"Agendamientos"}
      enableRedirect={hasPermission(PermissionsEnum.descargar_excel_agendamientos) ? true : false}
      textRedirect={"Generar Reporte Agendamiento"}
      urlRedirect={"/operaciones/planeacion/agendamientos/reporte-agendamiento"}
    >
      <SingleBoxTableTabsOnly>
        <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
          <Tab label="Preagendamientos" value={1} {...a11yProps(1)} />
          <Tab label="Agendadas" value={2} {...a11yProps(2)} />
          <Tab label="Recoordinadas" value={3} {...a11yProps(3)} />
          <Tab label="Instalacion Asignadas" value={4} {...a11yProps(4)} />
          <Tab label="Gestión Ventas" value={5} {...a11yProps(5)} />
          <Tab label="Rechazadas Planta Externa" value={6} {...a11yProps(6)} />
          <Tab label="Traslados Rechazados" value={7} {...a11yProps(7)} />
          <Tab label="Traslados Recoordinados" value={8} {...a11yProps(8)} />
        </FormTabsOnly>
      </SingleBoxTableTabsOnly>

      {/* ============ Preagendamientos ============ */}
      <CustomTabPanel value={valueTab} index={1}>
        <PreagendamientoPendientePageEstadoAceptacion
          estado_aceptacion={true}
        />
      </CustomTabPanel>

      {/* ============ Agendadas - Agenda ============ */}
      <CustomTabPanel value={valueTab} index={2}>
        {/* Sin prop: el componente usa por default APROBADO + FINALIZADO via
            estado_agendamiento_in, preservando los historicos de prod
            (FINALIZADO) e incluyendo los nuevos del flujo "reportar novedad
            -> Recordar" del tecnico (APROBADO). */}
        <AgendamientosAprobadosPage />
      </CustomTabPanel>

      {/* ============ Recoordinadas Espera - Agenda ============ */}
      <CustomTabPanel value={valueTab} index={3}>
        <AgendasPendingRecoordinacionPyLPage estado_agendamiento={EstadosAgendamientoEnumChoice.RECORDINADO} />
      </CustomTabPanel>

      {/* ============ Instalaciones Asignadas ============ */}
      <CustomTabPanel value={valueTab} index={4}>
        <InstallAsignadaTecnicoOTByState
          otState={EstadosOrdenTrabajoEnumChoice.EN_ESPERA}
        />
      </CustomTabPanel>

      {/* ============ GESTION ASESOR ============ */}
      <CustomTabPanel value={valueTab} index={5}>
        <PreagendamientoRechazadoPage />
      </CustomTabPanel>

      {/* ============ RECHAZADAS PLANTA EXTERNA ============ */}
      <CustomTabPanel value={valueTab} index={6}>
        <AgendasPendingRecoordinacionPyLPage estado_agendamiento={EstadosAgendamientoEnumChoice.PENDIENTE_RECORDINACION} />
      </CustomTabPanel>

      {/* ===== TRASLADOS RECHAZADOS (solo traslados; no toca instalaciones) ===== */}
      <CustomTabPanel value={valueTab} index={7}>
        <AgendasPendingRecoordinacionPyLPage
          estado_agendamiento={EstadosAgendamientoEnumChoice.PENDIENTE_RECORDINACION}
          tipoServicioMode="only"
        />
      </CustomTabPanel>

      {/* ===== TRASLADOS RECOORDINADOS (solo traslados; no toca instalaciones) ===== */}
      <CustomTabPanel value={valueTab} index={8}>
        <AgendasPendingRecoordinacionPyLPage
          estado_agendamiento={EstadosAgendamientoEnumChoice.RECORDINADO}
          tipoServicioMode="only"
        />
      </CustomTabPanel>

      {/* chat */}
      <ChatAgendamiento1 />
    </SingleTableBoxScene>
  );
};

export default AgendamientosPagePyL;
